export const DURATION = 6000;
export const DEFAULT_SEVERITY = "info";
